export enum ManagerScope {
  Direct = 0,
  Indirect = 1,
  Matrix = 2,
  Student = 3,
  Delegate = 4,
  HR = 5,
  LHR = 6,
  ALL = 99
}

export enum ActiveScope {
  Active = 0,
  Inactive = 1,
  All = 2
}

export class TeamMemberRequest {
  name?: string;
  functionId?: number;
  departmentId?: number;
  companyId?: number;
  scope: ManagerScope;
  activeScope: ActiveScope;
  to?: Date;
  from?: Date;
  delegateStudentId?: number;
  additionalFilter?: number;

  constructor(_name?: string, _scope?: ManagerScope) {
    this.name = _name;
    this.scope = _scope;
  }
}

export interface ITeamOverviewFilter {
  from: Date;
  to: Date;
  showAll: boolean;
}

export class TeamOverviewRequest {
  scope: ManagerScope;
  activeScope: ActiveScope;
  conversationsAndGoalsFilter: ITeamOverviewFilter;
  developmentFilter: ITeamOverviewFilter;
  functionId?: number;
  departmentId?: number;
  studentId?: number;
  delegateStudentId?: number;
  companyId?: number;
}
